import React from 'react';

import { Checkbox, ListItemText, MenuItem, Select } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';

export function RewardFilterEditCell({
  id,
  field,
  value,
  rewardOptions,
}: GridRenderEditCellParams & { rewardOptions: Array<{ id: string; label: string }> }) {
  const apiRef = useGridApiContext();
  const currentValue = Array.isArray(value) ? value : [];
  return (
    <Select
      multiple
      value={currentValue}
      onChange={(event) => apiRef.current.setEditCellValue({ id, field, value: event.target.value })}
      renderValue={(selected) => {
        if (!Array.isArray(selected) || selected.length === 0) {
          return 'All rewards';
        }
        return selected
          .map((rewardId) => rewardOptions.find((opt) => opt.id === rewardId)?.label || rewardId)
          .join(', ');
      }}
      size="small"
      fullWidth
    >
      {rewardOptions.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          <Checkbox checked={currentValue.includes(option.id)} />
          <ListItemText primary={option.label} />
        </MenuItem>
      ))}
    </Select>
  );
}
